<template>
  <div class="main-wrapper">
    <div v-if="!isIP">
      <div class="strategy-position">
        <p>
          <span
            :class="
              hasControlByPos[0] || hasControlByPos[1]
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Юридическое лицо является хозяйственным обществом, имеющим
          стратегическое значение для оборонно-промышленного комплекса и
          безопасности РФ, или является юридическим лицом, находящимся под
          прямым или косвенным контролем таких хозяйственных обществ
          (ФЕДЕРАЛЬНЫЙ ЗАКОН ОТ 21.07.2014 N 213-ФЗ)
        </p>
        <label>
          <input
            type="checkbox"
            v-model="hasControlByPos[0]"
            @click="hasControlByPos = [hasControlByPos[0], false]"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('IS_UNDER_STRATEGICAL_PLANT') != -1
            "
          />ДА
        </label>
        <label>
          <input
            type="checkbox"
            v-model="hasControlByPos[1]"
            @click="hasControlByPos = [false, hasControlByPos[1]]"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('PLAN_BUSINESS_PERIOD') != -1
            "
          />НЕТ
        </label>
      </div>
    </div>
    <div>
      <p>
        <span
          :class="hasInfo[0] || hasInfo[1] ? 'valid-field' : 'unvalid-field'"
          >➤</span
        >
        Наличие дополнительных офисов, заводских, складских и других подсобных
        помещений.
      </p>
      <label>
        <input
          type="checkbox"
          v-model="hasInfo[0]"
          @click="
            hasInfo = [hasInfo[0], false];
            fileRows[4].DISABLED = false;
            fileRows[4].FILE = null;
            fileRows[4].checkbox = false;
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('HAS_DOPOFFICES') != -1
          "
        />ДА
      </label>
      <label>
        <input
          type="checkbox"
          v-model="hasInfo[1]"
          @click="
            hasInfo = [false, hasInfo[1]];
            fileRows[4].DISABLED = true;
            fileRows[4].FILE = null;
            fileRows[4].checkbox = false;
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('HAS_DOPOFFICES') != -1
          "
        />НЕТ
      </label>
    </div>
    <div v-if="!isIP && !isBankrupt">
      <p>
        <span :class="validateFiles() ? 'valid-field' : 'unvalid-field'"
          >➤</span
        >
        Документы, подтверждающие местоположение
        {{ isIP ? "индивидуального предпринимателя" : "юридического лица" }},
        его постоянно действующего органа. Cведений о дополнительных офисах,
        заводских, складских и других подсобных помещениях.
      </p>
      <p class="necessary-table-not" v-if="!validateFiles()">
        Приложите хотя бы один документ.
      </p>
      <p
        class="necessary-table-not"
        v-if="hasInfo[0] && fileRows[4].FILE == null"
      >
        Обязательно приложите документ, подтверждающий право на использование
        дополнительных офисов.
      </p>
      <p class="min-one-file">
        Вы можете приложить только один файл или архив. Если необходимо
        приложить несколько документов, добавьте документы в архив и прикрепите
        архив.
      </p>
      <TableFiles :rowsParent="fileRows" @updateFiles="updateFiles" />
    </div>
    <div v-if="disCheckboxes && !isIP && !isBankrupt">
      <div class="strategy-position">
        <p>
          <span :class="anotherLocation ? 'valid-field' : 'unvalid-field'"
            >➤</span
          >
          Подтверждаем, что постоянно действующий орган управления находится по
          адресу, указанному в поле «фактический адрес», и гарантируем в течение
          двух месяцев внести изменения в регистрационные документы в
          соответствии с фактическим нахождением постоянно действующего органа
          управления
        </p>
        <label>
          <input
            type="checkbox"
            v-model="anotherLocation"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('DIFFERENT_LOCATION_AGREE') != -1
            "
          />ДА
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import TableFiles from "./parts/v-table-files.vue";
export default {
  name: "AnotherLocationDocs",
  props: {
    pageInfo: {},
    pageName: String,
    isIP: Boolean,
  },
  components: {
    TableFiles,
  },
  data: () => ({
    hasInfo: [false, false],
    sendFiles: [],
    hasControlByPos: [false, false],
    anotherLocation: false,
    fileRows: [],
    disCheckboxes: false,
    isBankrupt: false,
    sendData: {},
  }),
  methods: {
    updateFiles(files, isMounted) {
      this.sendFiles = files;
      if (!isMounted) this.$emit("updated");
      this.validation();
    },
    clearFileRows() {
      this.sendFiles = [];
      this.fileRows = [
        {
          id: 0,
          CAPTION:
            "Договор субаренды / Договор аренды между арендатором и арендодателем / Согласие арендодателя на субаренду",
          checkbox: false,
          FILE: null,
        },
        {
          id: 1,
          CAPTION: "Договор аренды недвижимого имущества",
          checkbox: false,
          FILE: null,
        },
        {
          id: 2,
          CAPTION: "Свидетельство на право собственности недвижимого имущества",
          checkbox: false,
          FILE: null,
        },
        {
          id: 3,
          CAPTION: "Выписка из ЕГРН",
          checkbox: false,
          FILE: null,
        },
        {
          id: 4,
          CAPTION:
            "Документ, подтверждающий право на использование дополнительных офисов, заводских, складских и других подсобных помещений",
          checkbox: false,
          FILE: null,
          DISABLED: true,
        },
      ];
    },
    checkUploadFiles(item) {
      let needToSend = false;
      let isExist = false;
      if (this.pageInfo.FILES != null) {
        this.pageInfo.FILES.forEach((file) => {
          if (file.DESCRIPTION == item.CAPTION) {
            if (item.FILE != null) {
              needToSend = item.FILE.name != file.DS_FILE_NAME;
            } else {
              needToSend = file.DS_FILE_NAME != null;
            }
            isExist = true;
          }
        });
        if (!isExist) needToSend = item.FILE != null;
      } else {
        needToSend = item.FILE != null;
      }
      return needToSend;
    },
    validateFiles() {
      let a = false;
      this.sendFiles.forEach((item) => (a = a || item.checkbox));
      return a;
    },
    validation() {
      var msg = "";
      if (!(this.hasControlByPos[0] || this.hasControlByPos[1]) && !this.isIP)
        msg +=
          "Юридическое лицо является хозяйственным обществом, имеющим стратегическое значение<br>";
      if (!this.isIP && !this.validateFiles() && !this.isBankrupt)
        msg += "Приложите хотя бы один документ<br>";
      if (
        !this.isIP &&
        this.hasInfo[0] &&
        this.fileRows[4].FILE == null &&
        !this.isBankrupt
      )
        msg +=
          "Приложите документ, подтверждающий право на использование дополнительных офисов.<br>";
      if (!(this.hasInfo[0] || this.hasInfo[1]))
        msg +=
          "Наличие дополнительных офисов, заводских, складских и других подсобных помещений<br>";
      if (
        !this.anotherLocation &&
        !this.isIP &&
        this.disCheckboxes &&
        !this.isBankrupt
      )
        msg +=
          "Подтверждаем, что постоянно действующий орган управления находится по адресу<br>";
      this.$emit("enableButtons", true, msg);
      if (msg.length == 0) {
        if (!this.isIP) {
          this.sendData.IS_UNDER_STRATEGICAL_PLANT = this.hasControlByPos[0];
          this.sendData.FILES = this.createFileList();
          if (
            this.pageInfo.FACT_ADDRESS_SAME_UR != null &&
            !this.pageInfo.FACT_ADDRESS_SAME_UR &&
            !this.isBankrupt
          )
            this.sendData.DIFFERENT_LOCATION_AGREE = this.anotherLocation;
          else delete this.sendData.DIFFERENT_LOCATION_AGREE;
        }
        this.sendData.HAS_DOPOFFICES = this.hasInfo[0];
        this.$emit("changePageSendData", this.sendData, !this.isIP);
      }
    },
    createFileList() {
      let files = [];
      this.sendFiles.forEach((item) => {
        var a = true;
        if (this.pageInfo.FILES != null) {
          this.pageInfo.FILES.forEach((file) => {
            if (
              file.DESCRIPTION == item.CAPTION &&
              item.FILE != null &&
              item.FILE.name == file.DS_FILE_NAME
            ) {
              a = false;
            }
          });
        }
        if (a && item.FILE != null) {
          files.push(item);
        }
      });
      if (this.pageInfo.FILES != null)
        this.pageInfo.FILES.forEach((file) => {
          var a = true;
          this.sendFiles.forEach((item) => {
            if (item.CAPTION == file.DESCRIPTION && item.FILE != null)
              a = false;
          });
          if (a) {
            files.push({ FILE: null, CAPTION: file.DESCRIPTION });
          }
        });
      return files;
    },
  },
  updated() {
    this.validation();
    this.$emit("updated");
  },
  created() {
    this.disCheckboxes =
      this.pageInfo.FACT_ADDRESS_SAME_UR != null &&
      !this.pageInfo.FACT_ADDRESS_SAME_UR;
    if (this.pageInfo.HAS_DOPOFFICES != null)
      this.hasInfo = [
        this.pageInfo.HAS_DOPOFFICES,
        !this.pageInfo.HAS_DOPOFFICES,
      ];
    if (this.pageInfo.DIFFERENT_LOCATION_AGREE != null)
      this.anotherLocation = this.pageInfo.DIFFERENT_LOCATION_AGREE;
    if (this.pageInfo.IS_BANKRUPT != null)
      this.isBankrupt = this.pageInfo.IS_BANKRUPT;
    if (this.pageInfo.IS_UNDER_STRATEGICAL_PLANT != null)
      this.pageInfo.IS_UNDER_STRATEGICAL_PLANT
        ? (this.hasControlByPos = [true, false])
        : (this.hasControlByPos = [false, true]);
    this.sendData.INN = this.pageInfo.INN;

    this.sendData.UPDATE_DATE = this.pageInfo.UPDATE_DATE;
    this.sendData.ID = this.pageInfo.ID;
    this.clearFileRows();
    this.fileRows[4].DISABLED = !this.hasInfo[0];

    if (this.pageInfo.FILES != null && !this.isBankrupt) {
      let files = this.pageInfo.FILES;
      files.forEach((item) => {
        this.fileRows.forEach((a) => {
          if (a.CAPTION == item.DESCRIPTION) {
            if (item.DS_FILE_NAME != null) {
              a.FILE = { name: item.DS_FILE_NAME };
              a.checkbox = true;
            }
            a.DISABLED = item.DISABLED != null && item.DISABLED;
          }
        });
      });
    }
    this.validation();
  },
};
</script>

<style scoped>
.main-wrapper {
  text-align: justify;
}
.necessary {
  color: red;
}
.main-checkboxes {
  padding-bottom: 10px;
}
.min-one-file {
  text-align: center;
  font-size: 12px;
}
</style>
